import firebase, { summaryRequestsCollection } from "../firebase";
import { v4 as uuidv4 } from "uuid";
import { getCurrentUserId , getBoardIdFromURL} from "./../util/common";


class AIGeneratorService {
  constructor() {}

  async createASummaryRequest(userEmail) {
 
    if (
      userEmail &&
      typeof userEmail === "string" &&
      userEmail?.length > 0 && 
      userEmail?.length < 50 && 
      userEmail?.includes("@") &&
      userEmail?.includes(".")
    ) {      
 
        return summaryRequestsCollection.add({
            userEmail: userEmail,            
            boardID: getBoardIdFromURL(),
            userId: getCurrentUserId(),
            requestRecivedDate: firebase.firestore.FieldValue.serverTimestamp(),
            requestSentDate: null,
            isViewed: null,
            isSent: false,
            chatGPTSummary: {}
        });
    }
    return null;
  }
 
}

export default new AIGeneratorService();
